// extracted by mini-css-extract-plugin
export default {"content":"NameStep_content__N2U0F","title":"NameStep_title__czM43"};